import { Autocomplete, Box, CircularProgress, Grid, Skeleton, Stack, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import DashboardCard from './DahsboardCard';
import DashboardChart from './DashboardChart';
import ResponseTable from './ResponseTable';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { useDispatch } from 'react-redux';
import {
  getCrmDashboardCards,
  getCrmDashboardTableData,
  getCroDashboardTableData,
  getCroList,
  getExamStatusBarData,
  getResMonth,
} from '../../../../redux/features/crmSlice';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { crmTypes } from '../../../../utils/employeeTypes';
import { getCROlistUnderProject } from '../../../../redux/features/CRDslice';
import { FOUNDATION_DEPARTMENT_ID } from '../../../../utils/constants/departmentDetails';
import { isSameUserType } from '../../../../utils/helperFunction';

export default function CRMdasboard({ CRO, CertificateGenerator }) {
  const [open, setOpen] = useState(false);
  const [cro, setCro] = useState({ userID: null, name: 'All' });
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));
  const [searchYear, setSearchYear] = useState(dayjs().format('YYYY'));
  const [croFromDate, setCroFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [croToDate, setCroToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));
  const dispatch = useDispatch();

  const {
    paginationData: { gridSize, pageNum, search },
  } = useSelector((state) => state.globalDataGrid);

  // -------------------------------------- redux
  const crosunderproject = useSelector((state) => state.crd?.crosunderproject);

  const { cardsData, cardLoading } = useSelector((state) => state.crm.impactReportCards);
  const { resMonth, resMonthLoading } = useSelector((state) => state.crm.impactReportResMonth);
  const { statusBar, statusBarLoading } = useSelector((state) => state.crm.impactReportExamStatusBar);
  const impactReportDashboardTableCrm = useSelector((state) => state.crm.impactReportDashboardTableCrm);
  const impactReportDashboardTableCro = useSelector((state) => state.crm.impactReportDashboardTableCro);
  const croList = useSelector((state) => state.crm.croList);
  const loading = useSelector((state) => state.crm.loading);
  const meta = useSelector((state) => state.crm.meta);
  // ----------------------------------------------------

  //impactReportResMonth bar month and count generating
  const [resMonths, resCounts] = useMemo(() => {
    const months = [],
      counts = [];
    if (resMonth?.length) {
      for (let { month, count } of resMonth) {
        months.push(month);
        counts.push(count);
      }
    }
    return [months, counts];
  }, [resMonth]);

  //ExamStatus Bar month and other 3 data generating
  const [ExamMonths, pendingExams, completedExams] = useMemo(() => {
    const months = [],
      pendingExams = [],
      completedExams = [];
    if (statusBar?.length) {
      for (let { month, pendingExam, completedExam } of statusBar) {
        months.push(month);
        pendingExams.push(pendingExam);
        completedExams.push(completedExam);
      }
    }
    return [months, pendingExams, completedExams];
  }, [statusBar]);

  // ----- fetch common without dependancy
  const profile = JSON.parse(localStorage.getItem('cred')).profile;

  const flag = isSameUserType({ roleArray: crmTypes, role: profile?.role });

  useEffect(() => {
    dispatch(flag ? getCroList({ search: '' }) : getCROlistUnderProject(FOUNDATION_DEPARTMENT_ID));
  }, [dispatch, flag]);

  // ----- fetch common with dependancy cards
  useEffect(() => {
    dispatch(getCrmDashboardCards({ cro_id: cro?.cro_id ?? null, fromDate, toDate }));
  }, [cro, fromDate, toDate, dispatch]);

  // ----- CRM fetch
  useEffect(() => {
    if (!CRO) {
      dispatch(
        getCrmDashboardTableData({
          year: searchYear,
          cro_id: cro?.cro_id ?? null,
        }),
      );
      dispatch(getExamStatusBarData({ year: searchYear, cro_id: cro?.cro_id ?? null }));
    }
  }, [searchYear, gridSize, pageNum, search, cro, dispatch, CRO]);

  // ----- CRO fetch
  useEffect(() => {
    if (CRO)
      dispatch(
        getCroDashboardTableData({
          search,
          page: pageNum,
          limit: gridSize,
          fromDate: croFromDate,
          toDate: croToDate,
        }),
      );
  }, [gridSize, pageNum, search, croFromDate, croToDate, dispatch, CRO]);
  // ------ fetch common Response Month
  useEffect(() => {
    dispatch(getResMonth({ year: searchYear, cro_id: cro?.cro_id ?? null }));
  }, [searchYear, cro, dispatch]);

  // Bar Object
  const responseVsMonthSeries = [
    {
      name: 'counts',
      data: resCounts,
    },
  ];

  const examStatus = [
    {
      name: 'Exam completed',
      data: completedExams,
    },
    {
      name: 'Exam to be completed',
      data: pendingExams,
    },
  ];

  // card path and keyName
  const cardKyeLabel = [
    { label: 'Total responses', value: 'totalResponses' },
    { label: 'Total pre assessments', value: 'totalPre' },
    { label: 'Total post assessments', value: 'totalPost' },
    { label: 'Total exam counts', value: 'totalExams' },
    { label: 'First session completed', value: 'firstSessionCompleted' },
    // { label: 'Total Impact Reports Generated' },
    {
      label: 'Total Impact Reports Downloaded',
      value: 'impactReportDownloaded',
      path: '/dashboard/impact-report-downloaded',
    },
    { label: 'Pending pre assessments', value: 'pendingPre', path: '/dashboard/pending-pre-assessments' },
    { label: 'Pending post assessments', value: 'pendingPost', path: '/dashboard/pending-post-assessments' },
    { label: 'Pending exams', value: 'pendingExam', path: '/dashboard/pending-exams' },
    { label: 'TC uploaded or last session done', value: 'tcUploaded' },
    {
      label: 'Total Impact Reports Pending for Download',
      value: 'pendingReportDownload',
      path: '/dashboard/pending-impact-report',
    },
  ];

  return (
    <GlobalWrapper title={`${CRO ? 'CRO' : 'Impact'} Dasboard`}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {CRO && (
          <GlobalDialog
            open={Boolean(open)}
            title={'Course Completion Ceritficate'}
            fullScreen={true}
            setOpen={setOpen}
            closeButton={true}
            content={<CertificateGenerator name={open} />}
          />
        )}
        <Stack px={3} gap={3}>
          {!CRO && (
            <Autocomplete
              options={
                flag
                  ? [{ userID: null, name: 'All' }, ...croList]
                  : [{ userID: null, name: 'All' }, ...crosunderproject]
              }
              getOptionKey={(e) => e.userID}
              getOptionLabel={(e) => e.name}
              loading={loading}
              onChange={(e, v) =>
                setCro((prev) => {
                  return { ...prev, cro_id: v?.userID ?? '' };
                })
              }
              sx={{ width: { xs: '100%', sm: 230 }, alignSelf: 'flex-end' }}
              renderInput={(params) => <TextField {...params} label="CRO Name" />}
            />
          )}
          <FromAndToDatePicker
            fromLabel="From Date"
            toLabel="To Date"
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
          {cardLoading ? (
            <Grid container spacing={2} mb={4}>
              {cardKyeLabel.map((e, i) => (
                <Grid item xl={2} lg={3} sm={6} md={4} xs={12} key={i}>
                  <Skeleton height={150} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={2} mb={4}>
              {cardKyeLabel.map((e, i) => (
                <Grid item xl={2} lg={3} sm={6} md={4} xs={12} key={i}>
                  <DashboardCard title={e.label} value={cardsData?.[e.value]} path={e.path} />
                </Grid>
              ))}
            </Grid>
          )}
          <Box display={'flex'} gap={2}>
            {CRO ? (
              <FromAndToDatePicker
                fromLabel="From Date"
                toLabel="To Date"
                fromDate={croFromDate}
                toDate={croToDate}
                setFromDate={setCroFromDate}
                setToDate={setCroToDate}
              />
            ) : (
              <DatePicker
                disableFuture
                sx={{
                  maxWidth: 150,
                }}
                views={['year']}
                label="Year"
                onChange={(value) => setSearchYear(value ? dayjs(value).format('YYYY') : '')}
                value={dayjs(searchYear)}
                renderInput={(params) => <TextField {...params} helperText={null} />}
              />
            )}
          </Box>
          <ResponseTable
            title={true}
            CRO={CRO}
            setOpen={setOpen}
            rows={CRO ? impactReportDashboardTableCro : impactReportDashboardTableCrm}
            loading={loading}
            meta={meta}
          />
          {CRO && (
            <DatePicker
              disableFuture
              sx={{
                maxWidth: 150,
              }}
              views={['year']}
              label="Year"
              onChange={(value) => setSearchYear(value ? dayjs(value).format('YYYY') : '')}
              value={dayjs(searchYear)}
              renderInput={(params) => <TextField {...params} helperText={null} />}
            />
          )}
          <Box
            sx={{
              width: '100%',
              overflowX: 'auto',
            }}
          >
            <Grid
              container
              sx={{
                minWidth: 550,
              }}
            >
              <Grid item lg={6} xs={12} p={3}>
                {resMonthLoading ? (
                  <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <DashboardChart series={responseVsMonthSeries} xCategories={resMonths} title={'Responses vs Month'} />
                )}
              </Grid>
              {!CRO && (
                <Grid item lg={6} xs={12} p={3}>
                  {statusBarLoading ? (
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <DashboardChart series={examStatus} xCategories={ExamMonths} />
                  )}
                </Grid>
              )}
            </Grid>
          </Box>
        </Stack>
      </LocalizationProvider>
    </GlobalWrapper>
  );
}
